import type { fieldList } from 'infrastructure/api'

export const sharedQueryFields: Record<string, fieldList> = {
  product: [
    'id',
    'title',
    { partner: ['name', 'id'] },
    'subject_id',
    'grade_id',
    'primary_tree_tree_id',
    { editable_tree: ['id', 'tree_id', 'version_id'] },
    'unassignable_at',
  ],
  partner: ['id', 'name'],
  productGroups: ['id', 'name', 'description', { products: ['id', 'title'] }],
  primaryTrees: [
    'id',
    'tree_id',
    'version_id',
    'generally_available',
    'is_current',
  ],
  editableTrees: ['id', 'tree_id', 'version_id', 'product_id'],
  crosswalkMappingSets: [
    'id',
    'name',
    'description',
    'source_framework_id',
    'target_framework_id',
    'method',
    'status',
    'created_by',
    {
      alignments: [
        'target_standard_code',
        'target_valid',
        'source_standard_code',
        'source_valid',
        'alignment_type',
        'note',
        'rating',
        'id',
        'mapping_set_id',
        'alignment_group_id',
        'source_description',
        'target_description',
      ],
    },
  ],
  crosswalkMappingSet: [
    'id',
    'name',
    'description',
    'source_framework_id',
    'target_framework_id',
    'method',
    'status',
    'created_by',
    {
      alignments: [
        'id',
        'mapping_set_id',
        'source_standard_code',
        'target_standard_code',
        'source_valid',
        'target_valid',
        'alignment_type',
        'rating',
        'note',
        'alignment_group_id',
        'source_description',
        'target_description',
      ],
    },
  ],
  standardAlignments: [
    'id',
    'mapping_set_id',
    'source_standard_code',
    'target_standard_code',
    'alignment_type',
    'rating',
    'note',
    'alignment_group_id',
  ],
  frameworks: ['id', 'name', 'jurisdiction', 'subject_id', 'version_label'],
}
